export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stringa da"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["a"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["caratteri"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valore non valido"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo obbligatorio"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Controlla i campi"])}
}